import { render, staticRenderFns } from "./ReceiptsPanel.vue?vue&type=template&id=be0fb786"
import script from "./ReceiptsPanel.vue?vue&type=script&lang=js"
export * from "./ReceiptsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports